import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Aftermarket() {
	return (
		<div>
			<NeonHero
				title="Aftermarket Mods"
				subtitle="Lift kits, exhaust, wheels & tires, audio, lighting, and more — installed with precision."
				primaryCta={{ label: 'Plan Your Build', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Popular Upgrades</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Suspension lifts and leveling</li>
					<li>Exhaust systems and intakes</li>
					<li>Wheel/tire packages and alignment</li>
					<li>Audio, lighting, and accessories</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Consultation and parts selection</li>
							<li>Scheduling and hub preparation</li>
							<li>Install, alignment and calibration</li>
							<li>Delivery and aftercare</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Drive Now, Pay Later with 0% APR for 12 months (OAC).</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Varies by build — many installs completed in 1–2 days.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
